import { render, staticRenderFns } from "./pfizer.vue?vue&type=template&id=2cea458d&"
import script from "./pfizer.vue?vue&type=script&lang=js&"
export * from "./pfizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports